import {
  IdashboardFilters,
  IinitialStateServerMap,
} from "../pages/Dashboard/Dashboard.type";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../config/featureFlags";

export const getFilteredData = (
  dataServer: IinitialStateServerMap,
  filters: IdashboardFilters
) => {
  if (dataServer?.clusters) {
    const filteredClusters = dataServer?.clusters.filter((cluster) => {
      let isFiltered = true;

      Object.keys(filters).forEach((key) => {
        if (!FEATURE_CLUSTER_BATTERY_METRIC_ENABLED && key === "battery_russia") {
          return;
        }
        if (
          filters[key as keyof typeof filters].value !== 0 &&
          filters[key as keyof typeof filters].value !== false
        ) {
          if (
            filters[key as keyof typeof filters].value !==
            cluster[key as keyof typeof cluster]
          ) {
            isFiltered = false;
          }
        }
      });

      if (isFiltered) return cluster;
    });
    const newObject = {...dataServer, clusters: filteredClusters};

    return newObject;
  }
};

// export default useFilteredData;
